import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { EmailConfigerationComponent } from './emailconfiguration/email-configeration.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PackageComponent } from './pakagelist/package.component';
import { TaxSettingComponent } from './tax-setting/shipper/taxsetting.component';
import { CustomerOnboardingComponent } from './customer-onboarding/customer-onboarding.component';
import { CoreModule } from 'src/app/core/core.module';
import { ReceiverTaxSettingComponent } from './tax-setting/receiver/taxsetting.component';
import { ImporterTaxSettingComponent } from './tax-setting/importer/taxsetting.component';
import { AdditionalServicesComponent } from './additional-services/additional-services.component';
import { EmailMappingComponent } from './email-mapping-list/email-mapping.component';
import { MotherShipperDetailsComponent } from './mother-shipper/mother-shipper-details/mother-shipper-details.component';
import { MotherShipperListComponent } from './mother-shipper/mother-shipper-list/mother-shipper-list.component';
import { RecieverSaveAddressComponent } from './reciever-save-address/reciever-save-address.component';
import { AutoprintlabelComponent } from './autoprintlabel/autoprintlabel.component';

@NgModule({
  declarations: [
    EmailConfigerationComponent,
    CustomerOnboardingComponent,
    PackageComponent,
    TaxSettingComponent,
    ReceiverTaxSettingComponent,
    ImporterTaxSettingComponent,
    AdditionalServicesComponent,
    EmailMappingComponent,
    MotherShipperDetailsComponent,
    MotherShipperListComponent,
    RecieverSaveAddressComponent,
    AutoprintlabelComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularEditorModule,
    CoreModule,
  ],
})
export class ConfigurationModule {}
